import { jsx } from 'react/jsx-runtime';
import React__default, { createContext } from 'react';
import MobileDetect from 'mobile-detect';
import useMedia from './useMedia.mjs';
import { MEDIA_QUERY } from '../constants/responsive.mjs';

var queries = [MEDIA_QUERY.ONLY_MOBILE];
var values = [true];
var initialValue = {
  isMobile: false
};
var IsMobileContext = /*#__PURE__*/createContext(initialValue);
function IsMobileProvider(_ref) {
  var children = _ref.children,
    ssrUserAgent = _ref.ssrUserAgent;
  var isMobile = useMedia(queries, values, false);
  var value = React__default.useMemo(function () {
    if (ssrUserAgent) {
      var detect = new MobileDetect(ssrUserAgent);
      return {
        isMobile: Boolean(detect.phone() || detect.mobile())
      };
    }
    return {
      isMobile: isMobile !== null && isMobile !== void 0 ? isMobile : false
    };
  }, [isMobile, ssrUserAgent]);
  return jsx(IsMobileContext.Provider, {
    value: value,
    children: children
  });
}
function useIsMobile() {
  var _React$useContext = React__default.useContext(IsMobileContext),
    isMobile = _React$useContext.isMobile;
  return isMobile;
}

export { IsMobileContext, IsMobileProvider, useIsMobile };
